/**
 * Instagram Reels — horizontal carousel
 * Arrows + mouse drag / touch swipe. Clicks still open links.
 */
(function () {
  var SELECTOR = '[data-insta-reels]';
  var DRAG_THRESHOLD = 8;
  var instances = new WeakMap();

  function initAll(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll ? scope.querySelectorAll(SELECTOR) : [];

    if (root && root.matches && root.matches(SELECTOR)) {
      initSection(root);
    }

    sections.forEach(initSection);
  }

  function initSection(section) {
    if (!section) return;
    if (instances.has(section)) destroySection(section);

    var viewport = section.querySelector('[data-insta-reels-viewport]');
    var track = section.querySelector('[data-insta-reels-track]');
    var prevBtn = section.querySelector('[data-insta-reels-prev]');
    var nextBtn = section.querySelector('[data-insta-reels-next]');
    var items = section.querySelectorAll('.insta-reels-section__item');

    if (!viewport || !track || !items.length) return;

    var state = {
      section: section,
      viewport: viewport,
      track: track,
      prevBtn: prevBtn,
      nextBtn: nextBtn,
      items: items,
      cardStep: 0,
      pointerActive: false,
      dragging: false,
      startX: 0,
      startScroll: 0,
      suppressClick: false,
      onScroll: null,
      onPointerDown: null,
      onPointerMove: null,
      onPointerUp: null,
      onResize: null,
      onClickCapture: null,
      onPrev: null,
      onNext: null,
      resizeObserver: null,
    };

    function measure() {
      var item = items[0];
      if (!item) {
        state.cardStep = 0;
        return;
      }
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      state.cardStep = item.getBoundingClientRect().width + gap;
    }

    function isMobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function centerOnMobile(force) {
      if (!isMobile()) {
        if (force) viewport.scrollLeft = 0;
        return;
      }
      measure();
      if (!state.cardStep || items.length <= 2) {
        updateArrows();
        return;
      }
      // Start so the middle pair is visible (not the first two)
      var startIndex = Math.floor((items.length - 2) / 2);
      viewport.scrollLeft = startIndex * state.cardStep;
      updateArrows();
    }

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      var maxScroll = viewport.scrollWidth - viewport.clientWidth;
      var canScroll = maxScroll > 2;
      prevBtn.hidden = !canScroll;
      nextBtn.hidden = !canScroll;
      if (!canScroll) return;

      var left = viewport.scrollLeft;
      prevBtn.disabled = left <= 2;
      nextBtn.disabled = left >= maxScroll - 2;
    }

    function scrollByCards(direction) {
      if (!state.cardStep) measure();
      if (!state.cardStep) return;
      viewport.scrollBy({
        left: direction * state.cardStep,
        behavior: 'smooth',
      });
    }

    function onScroll() {
      updateArrows();
    }

    function onPointerDown(event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      state.pointerActive = true;
      state.dragging = false;
      state.suppressClick = false;
      state.startX = event.clientX;
      state.startScroll = viewport.scrollLeft;
    }

    function onPointerMove(event) {
      if (!state.pointerActive) return;

      var dx = event.clientX - state.startX;
      if (!state.dragging && Math.abs(dx) < DRAG_THRESHOLD) return;

      if (!state.dragging) {
        state.dragging = true;
        state.suppressClick = true;
        viewport.classList.add('is-dragging');
        try {
          viewport.setPointerCapture(event.pointerId);
        } catch (e) {
          /* ignore */
        }
      }

      viewport.scrollLeft = state.startScroll - dx;
    }

    function onPointerUp() {
      if (!state.pointerActive) return;

      state.pointerActive = false;
      state.dragging = false;
      viewport.classList.remove('is-dragging');
      updateArrows();

      if (state.suppressClick) {
        window.setTimeout(function () {
          state.suppressClick = false;
        }, 0);
      }
    }

    function onClickCapture(event) {
      if (!state.suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
      state.suppressClick = false;
    }

    function onResize() {
      measure();
      centerOnMobile(true);
    }

    function onPrev(event) {
      event.preventDefault();
      event.stopPropagation();
      scrollByCards(-1);
    }

    function onNext(event) {
      event.preventDefault();
      event.stopPropagation();
      scrollByCards(1);
    }

    state.onScroll = onScroll;
    state.onPointerDown = onPointerDown;
    state.onPointerMove = onPointerMove;
    state.onPointerUp = onPointerUp;
    state.onClickCapture = onClickCapture;
    state.onResize = onResize;
    state.onPrev = onPrev;
    state.onNext = onNext;

    viewport.addEventListener('scroll', onScroll, { passive: true });
    viewport.addEventListener('pointerdown', onPointerDown);
    viewport.addEventListener('pointermove', onPointerMove);
    viewport.addEventListener('pointerup', onPointerUp);
    viewport.addEventListener('pointercancel', onPointerUp);
    viewport.addEventListener('lostpointercapture', onPointerUp);
    viewport.addEventListener('click', onClickCapture, true);
    window.addEventListener('resize', onResize);

    if (prevBtn) prevBtn.addEventListener('click', onPrev);
    if (nextBtn) nextBtn.addEventListener('click', onNext);

    if (typeof ResizeObserver !== 'undefined') {
      state.resizeObserver = new ResizeObserver(onResize);
      state.resizeObserver.observe(track);
      state.resizeObserver.observe(viewport);
    }

    // Autoplay muted videos
    section.querySelectorAll('.insta-reels-section__media video').forEach(function (video) {
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.muted = true;
      video.playsInline = true;
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    });

    requestAnimationFrame(function () {
      centerOnMobile(true);
    });
    // Images/videos can shift width after load — re-center once more
    window.setTimeout(function () {
      centerOnMobile(true);
    }, 150);

    instances.set(section, state);
  }

  function destroySection(section) {
    var state = instances.get(section);
    if (!state) return;

    state.viewport.removeEventListener('scroll', state.onScroll);
    state.viewport.removeEventListener('pointerdown', state.onPointerDown);
    state.viewport.removeEventListener('pointermove', state.onPointerMove);
    state.viewport.removeEventListener('pointerup', state.onPointerUp);
    state.viewport.removeEventListener('pointercancel', state.onPointerUp);
    state.viewport.removeEventListener('lostpointercapture', state.onPointerUp);
    state.viewport.removeEventListener('click', state.onClickCapture, true);
    window.removeEventListener('resize', state.onResize);
    if (state.prevBtn && state.onPrev) state.prevBtn.removeEventListener('click', state.onPrev);
    if (state.nextBtn && state.onNext) state.nextBtn.removeEventListener('click', state.onNext);
    if (state.resizeObserver) state.resizeObserver.disconnect();
    state.viewport.classList.remove('is-dragging');
    instances.delete(section);
  }

  function onReady() {
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (!event.target) return;
    var section =
      event.target.matches && event.target.matches(SELECTOR)
        ? event.target
        : event.target.querySelector(SELECTOR);
    if (section) destroySection(section);
  });
})();
